import { tv } from "tailwind-variants";

export const badgeContainer = tv({
  slots: {
    base: "flex flex-row font-semibold gap-1 p-1 rounded-md",
  },
  variants: {
    type: {
      low: {
        base: "bg-greendark-500 text-greenlight-300",
      },
      medium: {
        base: "bg-yellowdark-500 text-yellowlight-300",
      },
      high: {
        base: "bg-reddark-500 text-redlight-300",
      },
    },
  },
});
